import styled, { css } from 'styled-components';
import COLORS from '../../../constants/colors.js';
import { getSizeInPx } from '../../../methods/common.js';
import '../../../constants/fonts.js';
import '../../../constants/theme.js';
import '../../../constants/files.js';
import '../../../constants/color-variant.js';
import '../../../constants/zIndexList.js';

const ListContainer = styled.div `
    display: inline-flex;
    ${({ alignItems = "flex-start", justifyContent, flexWrap }) => {
    return css({
        alignItems,
        justifyContent,
        flexWrap,
    });
}}
`;
const ListItem = styled.div `
    display: inline-flex;
    &:not(:last-child)::after {
        content: "•";
        margin: 0 ${({ gap }) => getSizeInPx(gap)};
        color: ${({ separatorColor }) => separatorColor ? separatorColor : COLORS.GREY_600};
    }
`;

export { ListContainer, ListItem };
//# sourceMappingURL=DotSeparatedList.styles.js.map
